import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'Components/Atoms/IconButton/IconButton';
import { cn } from 'Utils/cn';
import OutlineArrowBottom from 'Components/Atoms/OutlineIcons/OutlineArrowBottom';
import Loading from 'Components/Atoms/Loading/Loading';

export default function InfiniteScroll(props) {
    const { hasNextPage = false, isFetching, fetchNextPage, className } = props;
    const sentinelRef = useRef(null);

    useEffect(() => {
        if (!hasNextPage || isFetching || !sentinelRef.current) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchNextPage();
            }
        });

        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [hasNextPage, isFetching, fetchNextPage]);

    return (
        <>
            <div className={cn('flex justify-center', className)}>
                {hasNextPage &&
                    (isFetching ? (
                        <Loading size="small" />
                    ) : (
                        <IconButton variant="ghost" icon={<OutlineArrowBottom />} onClick={fetchNextPage} />
                    ))}
            </div>

            {hasNextPage && !isFetching && <div ref={sentinelRef} />}
        </>
    );
}
InfiniteScroll.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    fetchNextPage: PropTypes.func.isRequired,
    hasNextPage: PropTypes.bool,
    className: PropTypes.string,
};
